var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "rb-change-style-product",
      class: { "rb-change-style-product--selected": _vm.isSelected },
      on: { click: _vm.onClick },
    },
    [
      _c("div", { staticClass: "rb-change-style-product__image" }, [
        _c("img", { attrs: { src: _vm.image, alt: _vm.imageAlt } }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rb-change-style-product__title" },
        [_vm._t("title")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }